// ── useTicketTypeManagement — 동적 관리 페이지 통합 훅 ────────────────────────
// 3개 도메인 훅을 결합해 페이지에서 필요한 전체 상태·핸들러를 제공한다
import { useEffect } from 'react';
import { useTicketManagement }       from './useTicketManagement';
import { usePersonsAndWorkflow }     from './usePersonsAndWorkflow';
import { useCompanyAndSettlement }   from './useCompanyAndSettlement';

export function useTicketTypeManagement() {
  const ticket  = useTicketManagement();
  const persons = usePersonsAndWorkflow();

  // 정산 카테고리 변경 핸들러가 categories/tickets에 의존하므로 주입
  const company = useCompanyAndSettlement({
    categories: ticket.categories,
    tickets:    ticket.tickets,
  });

  // 초기 데이터 로드 (피드백 옵션·미팅인계는 미팅지도 관리 설정 모달로 이관 — 2026-09-01)
  useEffect(() => {
    ticket.fetchCategories();
    ticket.fetchTickets();
    persons.fetchRcConfig();
    company.fetchExtCompanies();
    company.fetchSettlementSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    // 각 도메인 훅의 상태·핸들러를 모두 전개 (각 도메인마다 독립적인 saving 상태 유지)
    ...ticket,
    ...persons,
    ...company,
    // saving 이름 충돌 방지: 각 섹션 컴포넌트에 맞는 saving 전달
    ticketSaving:  ticket.saving,
    personsSaving: persons.saving,
    companySaving: company.saving,
  };
}
